import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import NoticeMessage from '@/plugin/noticemessage/noticemessage';
import { updateProfile, updateProfilePassword } from '../apis/profile-management';
import type {
  PasswordUpdateData,
  UseProfileManagementParams,
  UseProfileManagementReturn,
  UserProfileData,
} from '../types/profile-management.types';

const useProfileManagement = ({
  userID = null,
  // queryParams = '',
  // onDeleteSuccess = () => {},
  // onCreateSuccess = () => {},
  onUpdateSuccess = () => {},
  onResetFail = () => {},
}: UseProfileManagementParams): UseProfileManagementReturn => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const updateUserProfileMutation = useMutation({
    mutationFn: (userData: UserProfileData) => updateProfile(userData),
    onSuccess: () => {
      // TODO: Replace NoticeMessage with React-based toast/snackbar pattern
      new NoticeMessage(t('msg > update success'), {
        callback() {
          queryClient.invalidateQueries({ queryKey: userID ? ['user', userID] : ['user'] });
          queryClient.invalidateQueries({ queryKey: ['users'] });
          onUpdateSuccess();
        },
      });
    },
    onError: (err: unknown) => {
      onResetFail(err);
    },
  });

  const updateUserPasswordMutation = useMutation({
    mutationFn: (passwordData: PasswordUpdateData) => updateProfilePassword(passwordData),
    onSuccess: () => {
      // TODO: Replace NoticeMessage with React-based toast/snackbar pattern
      new NoticeMessage(t('msg > update success'), {
        callback() {
          queryClient.invalidateQueries({ queryKey: ['detailUserData', userID] });
          onUpdateSuccess();
        },
      });
    },
    onError: (err: unknown) => {
      onResetFail(err);
    },
  });

  return {
    updateUserProfile: updateUserProfileMutation.mutate,
    updateProfilePassword: updateUserPasswordMutation.mutate,
  };
};

export default useProfileManagement;
